<h1 mat-dialog-title>Previsualización de PDF - {{ data.fileName }}</h1>
<div mat-dialog-content>
  <div class="pdf-container">
    <object *ngIf="pdfUrl" [data]="pdfUrl" type="application/pdf" [name]="data.fileName" [title]="data.fileName" width="100%" height="100%">
      <iframe [src]="pdfUrl" [name]="data.fileName" width="100%" height="100%" frameborder="0">
        <embed [src]="pdfUrl" [name]="data.fileName" type="application/pdf" width="100%" height="100%" />
      </iframe>
    </object>
  </div>
</div>
<div mat-dialog-actions align="end" class="pdf-modal-actions">
  <button cButton color="primary" variant="outline" (click)="close()" class="me-2">Cerrar</button>
  <button cButton color="primary" (click)="downloadPdf()">Descargar PDF</button>
</div>
